module.exports = __webpack_public_path__ + "static/woocommerce-hero@2x-06b3e435e6128659aa83ffea5a781d1f.png";